export default __webpack_public_path__ + "assets/47fc91db2ecc1c69387bb206cf879b77.svg";